<template>
  <div>
    <v-container fluid grid-list-md text-center :class="sysForegroundColor">
      <v-layout row wrap>
        <v-flex>
          <v-img
            :src="require('../assets/logo.png')"
            contain
            height="300"
          ></v-img>
        </v-flex>
      </v-layout>
      <v-layout row wrap>
        <v-flex v-if="sysNombre == ''">
          <v-progress-circular
            indeterminate
            color="blue"
            :size="30"
            :width="5"
          ></v-progress-circular>
        </v-flex>
        <v-flex v-else>
          <span class="headline font-weight-light">
            {{ sysNombre }}
          </span>
        </v-flex>
      </v-layout>
    </v-container>
    <v-container fluid grid-list-md text-center>
      <v-layout row wrap>
        <v-flex xs12 md2 offset-md5>
          <v-card
            class="elevation-15 clickable transparente pa-1"
            v-ripple="{ center: true }"
            @click="abrirOpcion('Home')"
            dark
          >
            <v-card-text>
              <span class="overline">Iniciar</span><br />
              <v-icon>lock</v-icon>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
    <Mensaje
      :activo="mensajeActivo"
      :tipo="mensajeTipo"
      :titulo="mensajeTitulo"
      :detalle="mensajeDetalle"
      @ejecutarAccion="ejecutarAccion"
    />
  </div>
</template>

<script>
import HttpHelper from "@/store/HttpHelper";
import Mensaje from "@/components/Mensaje";
import Login from "./Login.vue";
export default {
  name: "Landing",
  components: {
    Mensaje
  },
  data() {
    return {
      mensajeActivo: false,
      mensajeTipo: "",
      mensajeTitulo: "",
      mensajeDetalle: ""
    };
  },
  computed: {
    sysNombre() {
      return this.$store.state.sysNombre;
    },

    sysForegroundColor() {
      return this.$store.state.sysForegroundColor;
    },
    nombreUsuario() {
      return this.$store.state.nombreUsuario;
    }
  },
  created() {
    this.$store.dispatch("setearAppTitulo", "Bienvenido");
    this.inicializarSistema();
  },
  methods: {
    inicializarSistema() {
      HttpHelper.get("Sistema", {
        id: 1
      })
        .then(response => {
          if (response.data.Resultado == "OK") {
            this.$store.dispatch("setearSysNombre", response.data.Nombre);
            this.$store.dispatch(
              "setearSysDireccionLocalidad",
              response.data.Direccion + " " + response.data.NombreLocalidad
            );
            this.$store.dispatch(
              "setearSysTelefonoEmail",
              "Tel." + response.data.Telefono + " " + response.data.Email
            );
            this.$store.dispatch(
              "setearSysId_TipoIva",
              response.data.Id_TipoIva
            );
            this.$store.dispatch(
              "setearSysAlicuotaIvaBasico",
              response.data.AlicuotaIvaBasico
            );
            this.$store.dispatch(
              "setearSysAlicuotaIvaDiferencial",
              response.data.AlicuotaIvaDiferencial
            );
            this.$store.dispatch(
              "setearSysForegroundColor",
              response.data.ForegroundColor
            );
            this.$store.dispatch(
              "setearSysBackgroundColor",
              response.data.BackgroundColor
            );
          }
        })
        .catch(error => {
          this.mostrarError(error);
        });
    },
    ejecutarAccion(accion) {
      if (accion == "CancelarError") this.mostrarMensaje(false);
    },
    abrirOpcion(ruta) {
      this.$router.push({ name: "Home" });
    },
    mostrarError(error) {
      var detalle;
      detalle =
        error.response === undefined
          ? error
          : error.response.data.ExceptionMessage;
      this.mostrarMensaje(true, "Error", null, detalle);
    },
    mostrarMensaje(activo, tipo, titulo, detalle) {
      if (activo) {
        this.mensajeTipo = tipo;
        this.mensajeTitulo = titulo;
        this.mensajeDetalle = detalle;
      }
      this.mensajeActivo = activo;
    }
  }
};
</script>
